import { useWorkflowBuilderSelector } from 'client/app/state/WorkflowBuilderStateContext';

// Using these parameter names directly is very fragile, but we don't have a way
// currently to target individial parameters and values in a nicer way.
export const REPLICATE_GROUPING_PARAMETER_NAME = 'ReplicateGrouping';
export const REPLICATE_GROUPING_PARAMETER_NAME_VALUE = 'Let Antha Optimize';

export default function useWorkflowElementParameters(elementInstanceId?: string) {
  const isLayoutOptimised = useWorkflowBuilderSelector(state => {
    const instance = state.elementInstances.find(i => i.Id === elementInstanceId);
    const instanceParams = instance ? state.parameters?.[instance.name] : {};
    const isLayoutOptimised =
      instanceParams[REPLICATE_GROUPING_PARAMETER_NAME] ===
      REPLICATE_GROUPING_PARAMETER_NAME_VALUE;
    return isLayoutOptimised;
  });

  return { isLayoutOptimised };
}
